import * as types from './action_types';
import FeedRetriever from '../../services/feed_retriever';
import DateMaster from '../utils/date_master';

export const followsFeed = (limit = 8) => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.FEED_RETRIEVING });
      const followsFeedData = await FeedRetriever.followsFeed(limit);
      const followsFeed = []
      for (let followsFeedDataItem of followsFeedData) {
        const followsFeedItem = {
          wordText: followsFeedDataItem.word_text,
          userName: followsFeedDataItem.user_name,
          userSlug: followsFeedDataItem.user_slug,
          createdAt: DateMaster.parseUTC(followsFeedDataItem.created_at)
        };

        followsFeed.push(followsFeedItem);
      }
      dispatch({ type: types.FEED_RETRIEVED, followsFeed });
    } catch(error) {
      dispatch({ type: types.FEED_ERROR, error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/feed/actions.js